// Текст согласия со ссылками на юр-документы (отдаются same-origin из /legal/).
// Открываем в новой вкладке, чтобы не терять состояние приложения/Mini App.
export function ConsentNotice() {
  return (
    <span>
      Я принимаю{' '}
      <a href="/legal/consent.html" target="_blank" rel="noopener" className="text-primary-600 underline">
        Согласие на обработку данных
      </a>
      ,{' '}
      <a href="/legal/privacy.html" target="_blank" rel="noopener" className="text-primary-600 underline">
        Политику конфиденциальности
      </a>{' '}
      и{' '}
      <a href="/legal/oferta.html" target="_blank" rel="noopener" className="text-primary-600 underline">
        Оферту
      </a>
    </span>
  );
}
